import Chart from "react-apexcharts";

const DonutChartPeplink = ({ allowance, totalUsage = 0, alerts }) => {
	const allowanceNum = parseFloat(allowance) || 0;
	const formattedAllowance = allowanceNum.toFixed(2);

	const formattedUsage = parseFloat(totalUsage) || 0;

	// Cap displayed usage at the allowance so percentages/remaining stay consistent
	const usage = formattedUsage > allowanceNum ? allowanceNum : formattedUsage;

	const usagePercentage = allowanceNum > 0 ? (usage / allowanceNum) * 100 : 0;
	const formatedUsagePercentage = isNaN(usagePercentage) ? 0 : usagePercentage.toFixed(2);

	const remaining = (allowanceNum - formattedUsage).toFixed(2);
	const formatedRemaining = remaining < 0 || isNaN(remaining) ? 0 : remaining;

	const allowanceGb = allowance === undefined ? "0 GB" : `${allowance} GB`;

	const options = {
		chart: {
			type: "donut",
			// let the chart fill its container width instead of a fixed px value
			width: "100%",
			redrawOnParentResize: true,
			redrawOnWindowResize: true,
		},
		labels: ["Usage", "Remaining"],
		colors: ["#0E9F6E", "#1B204C"],
		legend: {
			show: true,
			position: "bottom",
			labels: { colors: "#9CA3AF" },
			markers: { width: 10, height: 10, radius: 4 },
			itemMargin: { horizontal: 10, vertical: 6 },
		},
		plotOptions: {
			pie: {
				donut: {
					size: "65%",
					labels: {
						show: true,
						value: {
							color: "#FFFFFF",
							formatter: (val) => `${parseFloat(val).toFixed(2)}%`,
						},
						total: {
							show: true,
							label: "Total Usage",
							color: "#9CA3AF",
							fontSize: "16px",
							formatter: () => `${formatedUsagePercentage}%`,
						},
					},
				},
			},
		},
		stroke: {
			width: 0.5,
			colors: ["transparent"],
		},
		dataLabels: {
			enabled: true,
			formatter: (val) => `${val.toFixed(2)}%`,
		},
		tooltip: {
			theme: "dark",
			style: {
				fontSize: "14px",
				fontFamily: "Arial, sans-serif",
			},
			y: {
				formatter: (val) => `${val.toFixed(2)} GB`,
			},
			custom: ({ series, seriesIndex, w }) =>
				`<div style="background:#272B49; color:#FFFFFF; padding:8px; border-radius:6px; font-family:'Segoe UI', sans-serif;">
					<span style="color:#9CA3AF;">${w.globals.labels[seriesIndex]}:</span>
					<span style="font-weight:600;"> ${series[seriesIndex]}%</span>
				</div>`,
		},
		// breakpoints so the legend/labels don't crowd small containers
		responsive: [
			{
				breakpoint: 480,
				options: {
					legend: { position: "bottom", fontSize: "11px" },
					plotOptions: {
						pie: {
							donut: {
								labels: {
									value: { fontSize: "14px" },
									total: { fontSize: "13px" },
								},
							},
						},
					},
				},
			},
		],
	};

	const series = [parseFloat(formatedUsagePercentage), 100 - parseFloat(formatedUsagePercentage)];

	return (
		<div className="p-4">
			<div className="mx-auto w-full max-w-xs">
				<Chart options={options} series={series} type="donut" width="100%" />
			</div>

			<div className="col-span-2 mt-4 space-y-3 rounded-2xl bg-blue-gray bg-opacity-20 p-4">
				<div className="flex items-center justify-between">
					<span className="font-normal text-light-white text-sm">Allowance</span>
					<span className="rounded bg-blue-900 px-2.5 py-0.5 font-medium text-blue-300 text-xs">
						{allowanceGb}
					</span>
				</div>
				<div className="flex items-center justify-between">
					<span className="font-normal text-light-white text-sm">Total Usage</span>
					<span className="rounded bg-green-900 px-2.5 py-0.5 font-medium text-green-300 text-xs">
						{formattedUsage.toFixed(2)} GB
					</span>
				</div>
				<div className="flex items-center justify-between">
					<span className="font-normal text-light-white text-sm">Remaining</span>
					<span className="rounded bg-gray-600 px-2.5 py-0.5 font-medium text-gray-300 text-xs">
						{formatedRemaining} GB
					</span>
				</div>
				{alerts &&
					alerts.length > 0 &&
					alerts.map((alert, index) => (
						<div key={index} className="mb-2 flex justify-between">
							<span className="font-normal text-sm text-white leading-tight">
								{alert.threshold} %
							</span>
							<span
								className={`me-2 rounded px-2.5 py-0.5 font-medium text-xs ${
									alert.sent_at === null ? "bg-green-cyan text-white" : "bg-custom-red text-white"
								}`}
							>
								{alert.sent_at === null ? "Not yet" : new Date(alert.sent_at).toLocaleString()}
							</span>
						</div>
					))}
			</div>
		</div>
	);
};

export default DonutChartPeplink;
